module.exports = __webpack_public_path__ + "static/media/canada7.47e26793.jpg";